import { render } from "./TextAreaContact.vue?vue&type=template&id=2b536e7d"
import script from "./TextAreaContact.vue?vue&type=script&lang=js"
export * from "./TextAreaContact.vue?vue&type=script&lang=js"
script.render = render

export default script